export default {
  meta: {
    title: '单店详情',
    parentPath: ['/decision/brand'],
  },
};
